import React, {useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Collapse,
} from 'reactstrap';
import { useForm} from "react-hook-form";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import UdnLangs from "./_langs";
import Separator from "../../../components/Separator";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import TranslateButton from "../../../components/buttons/TranslateButton";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {
    FORM,
    INTERNATIONAL,
    REQUIRED
} from "../../../components/i18n/i18n";

// services & providers
import { udnService } from "../../../jwt/_services";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import SelectGeneric from "../../../components/select/selectGeneric";
import {typeUdnProvider} from "../../../providers/typeUdnProvider";
import {confirmAlert} from "react-confirm-alert";
import FirebaseTarget from "../../../components/firebaseTarget/firebaseTarget";

const UdnForm = ( props ) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, editMode, domainObject} = componentState?.data;


    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [dynamicModule, setDynamicModule] = useState( domainObject?.dynamicModule || false);
    const [home, setHome] = useState( domainObject?.home !== undefined ? domainObject?.home : false);
    const [buyStatus, setBuyStatus] = useState( domainObject?.buyStatus !== undefined ? domainObject?.buyStatus : null);
    const [hasMap, setHasMap] = useState(domainObject?.hasMap !== undefined ? domainObject?.hasMap : null);
    const [statusAtoB, setStatusAtoB] = useState(domainObject?.statusAtoB !== undefined ? domainObject?.statusAtoB : null);
    const [typeUdnId, setTypeUdnId] = useState(domainObject?.typeUdn?.id !== undefined ? domainObject?.typeUdn?.id : null);

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []
    const [openingTime, setOpeningTime] = useState(  domainObject?.openingTime || '' )
    const [closingTime, setClosingTime] = useState(  domainObject?.closingTime || '' )
    const [showFullGeneral, setShowFullGeneral] = useState(false); // minimized | regular
    const [showInternational, setShowInternational] = useState('regular'); // minimized | regular
    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }


    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            name                    : domainObject?.name,
            showOrder               : domainObject?.showOrder,
            logo                    : domainObject?.logo,
            image                   : domainObject?.image,
            code                    : domainObject?.code,
            color                   : domainObject?.color,
            photoCode               : domainObject?.photoCode,
            albumPhoto              : domainObject?.albumPhoto,
            productName             : domainObject?.productName,
            sivexCode               : domainObject?.sivexCode,
            status                  : domainObject?.status,
            home                    : domainObject?.home,
            buyStatus               : domainObject?.buyStatus,
            xapiId                  : domainObject?.xapiId,
            componentId             : domainObject?.componentId,
            versionAndroid          : domainObject?.versionAndroid,
            versionIos              : domainObject?.versionIos,
            colorDark               : domainObject?.colorDark,
            idSynxis                : domainObject?.idSynxis,
            minAgeChildren          : domainObject?.minAgeChildren,
            paxDefault              : domainObject?.paxDefault,
            paxRules                : domainObject?.paxRules,
            tags                    : domainObject?.tags,
            maxNights               : domainObject?.maxNights,
            minNights               : domainObject?.minNights,
            iconXkynet              : domainObject?.iconXkynet,
            webCode                 : domainObject?.webCode,
            urlMarketPlaceIos       : domainObject?.urlMarketPlaceIos,
            urlMarketPlaceAndroid   : domainObject?.urlMarketPlaceAndroid,
            mapOverlay               : domainObject?.mapOverlay,
            zoomLevel10              : domainObject?.zoomLevel10,
            zoomLevel12              : domainObject?.zoomLevel12,
            zoomLevel14              : domainObject?.zoomLevel14,
            zoomLevel16              : domainObject?.zoomLevel16,
        }
    });

    const submitSwitch = (data) => {
        if (props.generalPropouse) {
            confirmSubmit(data);
        } else {
            onSubmit(data);
        }
    }

    const confirmSubmit = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => {
            return <FirebaseTarget
                className={"udn"}
                data={data}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        }
    });

    const onSubmit = (data, fbData, _) => {
        let dataRequest = {
            item : {
                ...data,
                id: domainObject?.id,

                status: status,
                home: home,
                buyStatus: buyStatus,
                hasMap: hasMap,
                statusAtoB: statusAtoB,
                openingTime: openingTime,
                closingTime: closingTime,
                dynamicModule,
                langs: langs,
            }
        };

        if (props.generalPropouse) {
            dataRequest.noDb = fbData.noDb;
            dataRequest.allDb = fbData.allDb;
            dataRequest.existingDb = fbData.existingDb;

            fbData?.fbDataBase && fbData?.fbDataBase?.id && (dataRequest.fbDataBase = { id : fbData.fbDataBase.id });
        } else {
            dataRequest.fbDataBase = { id : app?.fbDataBase?.id }
        }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, udnService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, udnService, dataRequest)
        }

        returnToList()
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: udnService
        } );
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    const formAny = () => <>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label >{'Nombre'}</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Nombre"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="code">Código</Label>
                    <Input type="text"
                           name="code"
                           placeholder="Código"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="showOrder">Orden</Label>
                    <Input type="number" name="showOrder" id="showOrder"
                           placeholder="Orden"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Activo</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatus(!status)}
                            value={status}/>
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="home">Home Preference</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setHome(!home)}
                            value={home}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="but">Habilitar Compra</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setBuyStatus(!buyStatus)}
                            value={buyStatus}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >{'Tiene mapa ?'}</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setHasMap(!hasMap)}
                            value={hasMap}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >{'Habilitar AtoB ?'}</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatusAtoB(!statusAtoB)}
                            value={statusAtoB}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Hora de apertura</Label>
                    <Input
                        type="time"
                        name="openingTime"
                        value={ openingTime }
                        onChange={ e => setOpeningTime( e.target.value ) }
                        innerRef={ register }
                        placeholder="Ingrese hora"
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Hora de cierre</Label>
                    <Input
                        type="time"
                        name="closingTime"
                        value={ closingTime }
                        onChange={ e => setClosingTime( e.target.value ) }
                        innerRef={ register }
                        placeholder="Ingrese hora"
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label >Código Sivex</Label>
                    <Input type="text" name="sivexCode" id="sivexCode"
                           placeholder="Código sistema Sivex"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Nombre producto Sivex</Label>
                    <Input type="text" name="productName" id="productName"
                           placeholder="Nombre producto sistema Sivex"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="logo">Logo</Label>
                    <Input type="name" name="logo" id="logo"
                           placeholder="Logo"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="image">Imagen</Label>
                    <Input type="text" name="image" id="image"
                           placeholder="Imagen"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>

            <Col md="2">
                <FormGroup>
                    <Label >Código Fotos</Label>
                    <Input type="number" name="photoCode" id="photoCode"
                           placeholder="Código sistema Fotografías"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Album foto</Label>
                    <Input type="text" name="albumPhoto" id="albumPhoto"
                           placeholder="Nombre del album"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="xapiId">Xapi Id</Label>
                    <Input type="number" name="xapiId" id="xapiId"
                           placeholder="Xapi Id"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="idSynxis">Código Synxis </Label>
                    <Input type="text" name="idSynxis" id="idSynxis"
                           placeholder="Código sistema Synxis"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Component Id</Label>
                    <Input type="text" name="componentId"
                           placeholder="Id de componente"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="color">Color</Label>
                    <Input type="color" name="color" id="color"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="colorDark">Color Obscuro </Label>
                    <Input type="color" name="colorDark" id="colorDark"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="minAgeChildren">Edad minima</Label>
                    <Input type="number" name="minAgeChildren" id="minAgeChildren"
                           placeholder="13"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="paxDefault">Pax default </Label>
                    <Input type="text" name="paxDefault" id="paxDefault"
                           placeholder="2/0 : Adulto/Menor"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="paxRules">Reglas de pax </Label>
                    <Input type="text" name="paxRules" id="paxRules"
                           placeholder="Adulto/Menor|Adulto/Menor"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Minimo de noches</Label>
                    <Input type="number" name="minNights" id="minNights"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Maximo de noches</Label>
                    <Input type="number" name="maxNights" id="maxNights"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>{'Tipo de UDN'}</Label>
                    <br/>
                    <SelectGeneric
                        initialValue={typeUdnId}
                        setExternalValue={setTypeUdnId}
                        provider={typeUdnProvider}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label >{ 'Versión Android'}</Label>
                    <Input type="number"
                           step="0.01"
                           name="versionAndroid"
                           id="versionAndroid"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="8">
                <FormGroup>
                    <Label >{'Url Marketplace Android'}</Label>
                    <Input type="text"
                           name="urlMarketPlaceAndroid"
                           id="urlMarketPlaceAndroid"
                           placeholder="Url Marketplace Android"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label >{'Versión iOS'}</Label>
                    <Input type="number"
                           step="0.01"
                           name="versionIos"
                           id="versionIos"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="8">
                <FormGroup>
                    <Label >{'Url Marketplace iOS'}</Label>
                    <Input type="text"
                           name="urlMarketPlaceIos"
                           id="urlMarketPlaceIos"
                           placeholder="Url Marketplace iOS"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formPark = () => <>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label >{'Nombre'}</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Nombre"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="code">Código</Label>
                    <Input type="text"
                           name="code"
                           placeholder="Código"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Código Sivex</Label>
                    <Input type="text" name="sivexCode" id="sivexCode"
                           placeholder="Código sistema Sivex"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="webCode">Código Web </Label>
                    <Input type="text" name="webCode" id="webCode"
                           placeholder="Código Web"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Nombre producto Sivex</Label>
                    <Input type="text" name="productName" id="productName"
                           placeholder="Nombre producto sistema Sivex"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="1">
                <FormGroup>
                    <Label >Activo</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatus(!status)}
                            value={status}/>
                </FormGroup>
            </Col>
            <Col md="1">
                <FormGroup>
                    <Label htmlFor="home">Home Preference</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setHome(!home)}
                            value={home}/>
                </FormGroup>
            </Col>
            <Col md="1">
                <FormGroup>
                    <Label htmlFor="but">Habilitar Compra</Label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        innerRef={register}
                        onChange={_ => setBuyStatus(!buyStatus)}
                        value={buyStatus}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="but">¿Es un módulo dinámico?</Label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        innerRef={register}
                        onChange={_ => setDynamicModule(!dynamicModule)}
                        value={dynamicModule}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="logo">Logo</Label>
                    <Input type="name" name="logo" id="logo"
                           placeholder="Logo"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="image">Imagen</Label>
                    <Input type="text" name="image" id="image"
                           placeholder="Imagen"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="showOrder">Orden</Label>
                    <Input type="number" name="showOrder" id="showOrder"
                           placeholder="Orden"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Código Fotos</Label>
                    <Input type="number" name="photoCode" id="photoCode"
                           placeholder="Código sistema Fotografías"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Album foto</Label>
                    <Input type="text" name="albumPhoto" id="albumPhoto"
                           placeholder="Nombre del album"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="xapiId">Xapi Id</Label>
                    <Input type="number" name="xapiId" id="xapiId"
                           placeholder="Xapi Id"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>{'Tipo de UDN'}</Label>
                    <br/>
                    <SelectGeneric
                        initialValue={typeUdnId}
                        setExternalValue={setTypeUdnId}
                        provider={typeUdnProvider}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label >{ 'Versión Android'}</Label>
                    <Input type="number"
                           step="0.01"
                           name="versionAndroid"
                           id="versionAndroid"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="8">
                <FormGroup>
                    <Label >{'Url Marketplace Android'}</Label>
                    <Input type="text"
                           name="urlMarketPlaceAndroid"
                           id="urlMarketPlaceAndroid"
                           placeholder="Url Marketplace Android"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label >{'Versión IOS'}</Label>
                    <Input type="number"
                           step="0.01"
                           name="versionIos"
                           id="versionIos"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="8">
                <FormGroup>
                    <Label >{'Url Marketplace iOS'}</Label>
                    <Input type="text"
                           name="urlMarketPlaceIos"
                           id="urlMarketPlaceIos"
                           placeholder="Url Marketplace iOS"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Collapse isOpen={showFullGeneral} >
            <Row>

            </Row>
        </Collapse>
    </>


    const formMapLanding = () => <>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label >{'Nombre'}</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Nombre"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="code">Código</Label>
                    <Input type="text"
                           name="code"
                           placeholder="Código"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>{'Tipo de UDN'}</Label>
                    <br/>
                    <SelectGeneric
                        initialValue={typeUdnId}
                        setExternalValue={setTypeUdnId}
                        provider={typeUdnProvider}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="showOrder">Orden</Label>
                    <Input type="number" name="showOrder" id="showOrder"
                           placeholder="Orden"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Activo</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatus(!status)}
                            value={status}/>
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label htmlFor="logo">Logo</Label>
                    <Input type="name" name="logo" id="logo"
                           placeholder="Logo"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label >Overlay de Mapa</Label>
                    <Input type="text" name="mapOverlay"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="3">
                <FormGroup>
                    <Label >Zoom Lv 10</Label>
                    <Input type="text"
                           name="zoomLevel10"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label >Zoom Lv 12</Label>
                    <Input type="text"
                           name="zoomLevel12"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label >Zoom Lv 14</Label>
                    <Input type="text"
                           name="zoomLevel14"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label >Zoom Lv 16</Label>
                    <Input type="text"
                           name="zoomLevel16"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formHotel = () => <>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label >{'Nombre'}</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Nombre"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="code">Código</Label>
                    <Input type="text"
                           name="code"
                           placeholder="Código"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="logo">Logo</Label>
                    <Input type="name" name="logo" id="logo"
                           placeholder="Logo"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="showOrder">Orden</Label>
                    <Input type="number" name="showOrder" id="showOrder"
                           placeholder="Orden"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label htmlFor="color">Color</Label>
                    <Input type="color" name="color" id="color"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label htmlFor="colorDark">Color Obscuro </Label>
                    <Input type="color" name="colorDark" id="colorDark"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="idSynxis">Código Synxis </Label>
                    <Input type="text" name="idSynxis" id="idSynxis"
                           placeholder="Código sistema Synxis"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="webCode">Código Web </Label>
                    <Input type="text" name="webCode" id="webCode"
                           placeholder="Código Web"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="status">Activo</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatus(!status)}
                            value={status}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="but">Habilitar Compra</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setBuyStatus(!buyStatus)}
                            value={buyStatus}/>
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="minAgeChildren">Edad minima</Label>
                    <Input type="number" name="minAgeChildren" id="minAgeChildren"
                           placeholder="13"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="paxDefault">Pax default </Label>
                    <Input type="text" name="paxDefault" id="paxDefault"
                           placeholder="2/0 : Adulto/Menor"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="paxRules">Reglas de pax </Label>
                    <Input type="text" name="paxRules" id="paxRules"
                           placeholder="Adulto/Menor|Adulto/Menor"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Minimo de noches</Label>
                    <Input type="number" name="minNights" id="minNights"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Maximo de noches</Label>
                    <Input type="number" name="maxNights" id="maxNights"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Collapse isOpen={showFullGeneral} >
            <Row>

            </Row>
        </Collapse>
    </>

    const formEvents = () => <>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label >{'Nombre'}</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Nombre"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="code">Código</Label>
                    <Input type="text"
                           name="code"
                           placeholder="Código"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="showOrder">Orden</Label>
                    <Input type="number" name="showOrder" id="showOrder"
                           placeholder="Orden"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="status">Activo</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatus(!status)}
                            value={status}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Habilitar Compra</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setBuyStatus(!buyStatus)}
                            value={buyStatus}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >{'Tiene mapa ?'}</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setHasMap(!hasMap)}
                            value={hasMap}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >{'Habilitar AtoB ?'}</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatusAtoB(!statusAtoB)}
                            value={statusAtoB}/>
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="3">
                <FormGroup>
                    <Label>Hora de apertura</Label>
                    <Input
                        type="time"
                        name="openingTime"
                        value={ openingTime }
                        onChange={ e => setOpeningTime( e.target.value ) }
                        innerRef={ register }
                        placeholder="Ingrese hora"
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Hora de cierre</Label>
                    <Input
                        type="time"
                        name="closingTime"
                        value={ closingTime }
                        onChange={ e => setClosingTime( e.target.value ) }
                        innerRef={ register }
                        placeholder="Ingrese hora"
                    />
                </FormGroup>
            </Col>



        </Row>
        <Collapse isOpen={showFullGeneral} >
            <Row>

            </Row>
        </Collapse>
    </>

    const formFerry = () => <>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label >{'Nombre'}</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Nombre"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="code">Código</Label>
                    <Input type="text"
                           name="code"
                           placeholder="Código"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="sivexCode">Código Sivex</Label>
                    <Input type="text" name="sivexCode" id="sivexCode"
                           placeholder="Código sistema Sivex"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="webCode">Código Web </Label>
                    <Input type="text" name="webCode" id="webCode"
                           placeholder="Código Web"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="name">Nombre producto Sivex</Label>
                    <Input type="text" name="productName" id="productName"
                           placeholder="Nombre producto sistema Sivex"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Component Id</Label>
                    <Input type="text" name="componentId"
                           placeholder="Id de componente"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="status">Activo</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setStatus(!status)}
                            value={status}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="home">Home Preference</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setHome(!home)}
                            value={home}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="but">Habilitar Compra</Label><br/>
                    <Switch animate={true} offText={"No"} onText={"Si"}
                            innerRef={register}
                            onChange={_ => setBuyStatus(!buyStatus)}
                            value={buyStatus}/>
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="logo">Logo</Label>
                    <Input type="name" name="logo" id="logo"
                           placeholder="Logo"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="image">Imagen</Label>
                    <Input type="text" name="image" id="image"
                           placeholder="Imagen"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="showOrder">Orden</Label>
                    <Input type="number" name="showOrder" id="showOrder"
                           placeholder="Orden"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Código Fotos</Label>
                    <Input type="number" name="photoCode" id="photoCode"
                           placeholder="Código sistema Fotografías"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label >Album foto</Label>
                    <Input type="text" name="albumPhoto" id="albumPhoto"
                           placeholder="Nombre del album"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label htmlFor="xapiId">Xapi Id</Label>
                    <Input type="number" name="xapiId" id="xapiId"
                           placeholder="Xapi Id"
                           innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Collapse isOpen={showFullGeneral} >
            <Row>

            </Row>
        </Collapse>
    </>

    const getInternational = () => {
        return (
            //  Contenedor con titulo
            <div className={'form-container'}>
                <div className={''}>
                    <h2>{INTERNATIONAL}</h2>
                </div>
                <div className={''}>
                    <Row>
                        <UdnLangs appCode={app?.code} langs={langs} setLangs={setLangs} translatableLangs={translatableLangs} />
                    </Row>
                </div>
            </div>
        )
    }

    return (<>
            <Form onSubmit={ handleSubmit(submitSwitch) }>
                <Card className={'card-modal-big'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { (domainObject?.title || domainObject?.name || '') }</h2>
                            <br />
                            <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                        </>
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode &&
                                <>
                                    <GenericButton
                                        style={'table'}
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                    <TranslateButton item={domainObject} service={udnService} path={path}/>
                                    <GenericButton
                                        style={'danger-secondary'}
                                        toolTip={TT_DELETE}
                                        icon={'fa-trash'}
                                        permission={'delete'}
                                        onClick={_ => confirmDelete(domainObject)}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={returnToList}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        {(
                            function() {
                                switch (app?.code) {
                                    case "PARK" :
                                        return formPark()
                                    case "XKYNET" :
                                        return formMapLanding()
                                    case "MAP_LANDING" :
                                        return formMapLanding()
                                    case "HCDP":
                                        return formHotel()
                                    case "HOTEL" :
                                        return formHotel()
                                    case "EVENTS" :
                                        return formEvents()
                                    case "FERRY" :
                                        return formFerry()
                                    default:
                                        return formAny()
                                }
                            })()}
                        { getInternational() }
                    </CardBody>
                </Card>
            </Form>
            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setItem,
    setForm
})

export default connect(mapStateToProps, mapActionsToProps)(UdnForm)
